import { Component } from '@angular/core';
import { ClientsSearchTableComponent } from 'clients-search-lib';

@Component({
  selector: 'howden-search-clients',
  templateUrl: './search-clients.component.html',
  styleUrls: ['./search-clients.component.scss'],
  imports: [ClientsSearchTableComponent]
})
export class SearchClientsComponent { }
